/**
 * Mención resaltada: negrita + color, sin avatar ni pastilla.
 */
export function MentionChip({ label, className = '' }) {
    return (
        <span className={`mention-chip ${className}`.trim()}>
            <span className="mention-chip__label">{label}</span>
        </span>
    );
}
